import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBarExpandedTabWithPermission } from '../app.data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-admin',
    template: '',
    standalone: false
})
export class AdminComponent implements OnInit {

    constructor(private route: ActivatedRoute, private router: Router) {}

    ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this)).subscribe(data => {
            if (!data) return;
            const tab: AppBarExpandedTabWithPermission = data.appBarExpandedTabs
                && data.appBarExpandedTabs.tabs.length
                ? data.appBarExpandedTabs.tabs.filter(it => !it.hidden)[0] : undefined;
            if (tab) {
                this.router.navigate([tab.url], { queryParams: tab.query });
            }
        });
    }
}
